function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP licence number
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { licenceNumber } from '../../actions/index';
import TextInput from '../text-input/TextInput';
import './LicenceNumber.scss';
import { jsx as _jsx } from "react/jsx-runtime";
export class LicenceNumber extends React.Component {
  render() {
    const {
      licenceNumber,
      setLicenceNumber
    } = this.props;
    return /*#__PURE__*/_jsx(TextInput, {
      handleChange: setLicenceNumber,
      onBlur: setLicenceNumber,
      label: "Licence number",
      name: "licenceNumber",
      section: "licence-details"
      // $FlowFixMe
      ,
      values: {
        licenceNumber
      }
    });
  }
}
_defineProperty(LicenceNumber, "defaultProps", {
  licenceNumber: {
    value: ''
  }
});
const mapStateToProps = ({
  licenceNumber
}) => {
  return {
    licenceNumber
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setLicenceNumber: value => {
      dispatch(licenceNumber(value));
    }
  };
};
const VisibleLicenceNumber = connect(mapStateToProps, mapDispatchToProps)(LicenceNumber);
export default VisibleLicenceNumber;